(function () {

  'use strict';

  function pxApplicationsContextMenu() {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        selectedTab: '=selectedTab',
        resource: '=resource',
        callback: '&callback'
      },
      templateUrl: 'app/components/applications/_applicationsContextMenu/applicationsContextMenu.template.html',
      link: function (scope, element, attrs) {

        scope.closePopup = function () {
          scope.callback();
        };

      }
    };
  }

  pxApplicationsContextMenu.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxApplicationsContextMenu', pxApplicationsContextMenu);

})();
